/* Miravel - custom.js */
if (window.matchMedia("(max-width: 768px)").matches) {
  window.onscroll = function () {
    var y = document.documentElement.scrollTop || document.body.scrollTop,
        b = document.getElementById('scrollToTop');
    if (b) b.style.display = y > 1200 ? 'block' : 'none';
  };
}

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ', '').replace(',', '.').trim();
  var compare = parseFloat($('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',', '.'));
  $('.product-label.product-label--on-sale span').text('R$ ' + (compare - preco).toFixed(2).replace('.', ','));
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0];
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%');
  var calculo = ((parseFloat(preco) + 0) * 1.1979 / 12).toFixed(2).replace('.', ',');
  $('.parcelamento').html('<span>em ate 12x de <b>R$ ' + calculo + '</b></span>');
}
$(".block-swatch__radio").change(function () { setTimeout(parcelamento, 150); });

/* FontAwesome 6: o kit original do tema retorna 403 e deixava os icones de
   pagamento (cartao, PIX, boleto) invisiveis. */
(function () {
  if (document.querySelector('link[data-mv-fa]')) return;
  var l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css';
  l.setAttribute('data-mv-fa', '1');
  document.head.appendChild(l);
})();

/* Header: textos quebravam em 2-3 linhas (line-height alto + colunas estreitas). */
(function () {
  if (document.getElementById('mv-hdr')) return;
  var s = document.createElement('style');
  s.id = 'mv-hdr';
  s.textContent = '@media (min-width:1000px){#shopify-section-header .header__action-item span,#shopify-section-header select,#shopify-section-header label,#shopify-section-header .header__action-item a{white-space:nowrap!important;line-height:1.25!important;}#shopify-section-header .sub-txt-header-sections,#shopify-section-header .header__action-item-title,#shopify-section-header .secttions-header-title{display:none!important;}#shopify-section-header .header__action-item{align-items:center;}}#shopify-section-miravel_categorias .collection-item__title{display:none!important;}#shopify-section-announcement-bar .announcement-bar__inner{display:flex!important;align-items:center;justify-content:center;gap:22px;flex-wrap:wrap;}#shopify-section-announcement-bar .announcement-bar__content{padding-left:0!important;padding-right:0!important;}#shopify-section-announcement-bar .announcement-bar__button{position:static!important;margin:0!important;flex:0 0 auto;}#shopify-section-header .search-bar{align-self:center!important;}#shopify-section-header .search-bar__filter,#shopify-section-header .search-bar__filter-label{display:flex!important;align-items:center!important;}#shopify-section-header .search-bar__filter-label{height:100%;}.color-line{background:linear-gradient(90deg,#0F5C4B 0%,#1F7A63 22%,#E9C46A 50%,#1F7A63 78%,#0F5C4B 100%)!important;height:4px!important;}';
  document.head.appendChild(s);
})();

/* O modulo de frete dos Correios imprime "Frete Gratis" fixo no tema.
   Trocamos pelo texto correto (o frete e calculado no checkout). */
(function () {
  function fix() {
    document.querySelectorAll('.txt-frete').forEach(function (e) {
      if (/gr[áa]tis/i.test(e.textContent)) e.textContent = 'Frete calculado no checkout';
    });
  }
  fix(); [600, 1800, 4000].forEach(function (t) { setTimeout(fix, t); });
})();
